module.exports = __webpack_public_path__ + "static/media/short_es-419.7c3a3568.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/short_es-419.png
// module id = 955
// module chunks = 0